import { connect } from "react-redux";
import { Store } from "Store/index";
import { Page, PageProps } from "./page";

type StateProps = Pick<PageProps, "content" | "layout">;

function resolvePage(state: Store): StateProps {
  const activeRoute = state.application.active_route;
  const routeMappings = state.application.route_page;
  const pages = state.pages.pages;
  let content: StateProps["content"] = "";
  let layout: StateProps["layout"] = "GENERIC";

  const pageId = routeMappings.find(rm => rm.route === activeRoute.id);
  if (pageId !== undefined) {
    const page = pages.find(page => page.id === pageId.page);
    if (page !== undefined) {
      content = page.content;
      layout = resolveLayout(page.context);
    }
  }

  return {
    content,
    layout
  };
}

function resolveLayout(
  context: Store["pages"]["pages"][0]["context"]
): StateProps["layout"] {
  switch (context) {
    case "GENERIC":
      return "GENERIC";
    case "HEROIC":
      return "HEROIC";
    case "ERROR":
      return "ERROR";
    default:
      return undefined;
  }
}

function mapStateToProps(state: Store): StateProps {
  return resolvePage(state);
}

const pageHOC = connect(mapStateToProps, () => ({}))(Page);
export { pageHOC as PageHOC };
